import React from "react";
import QuickMenu from "../../components/QuickMenu/QuickMenu";
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  const html = `
<h2 class="page-title">
  Gizlilik Politikası
  <span class="tarih">
    <i class="fa fa-calendar"></i>
  </span>
</h2>

<div class="row haber-detay-box">
  <div class="col-lg-12">
    <div class="detay">
      <p style="text-align: center;">&nbsp;</p>
      <p style="text-align: center;"><span style="font-size: 14pt;"><strong>İSKENDERUN BELEDİYESİ</strong></span></p>
      <p style="text-align: center;"><span style="font-size: 14pt;"><strong>GİZLİLİK POLİTİKASI</strong></span></p>
      <p>&nbsp;</p>

      <h3><strong>1. Veri Sorumlusu</strong></h3>
      <p><strong>Veri sorumlusu:</strong> İskenderun Belediyesi</p>
      <p><strong>Adres:</strong> Yenişehir, Mareşal Fevzi Çakmak Cd. No:48, 31200 İskenderun/Hatay, Türkiye</p>
      <p><strong>Telefon:</strong> 444 19 39</p>
      <p><strong>E-posta:</strong> bilgi@iskenderun.bel.tr</p>
      <p><strong>KVKK kapsamındaki başvurular için:</strong> bilgi@iskenderun.bel.tr</p>
      <p>&nbsp;</p>

      <h3><strong>2. Toplanan Veriler ve İşleme Amaçları</strong></h3>
      <p>Uygulama'yı kullanmanız sırasında aşağıdaki kategori veriler işlenebilir:</p>
      
      <ul>
        <li><strong>Kimlik Bilgileri</strong> (ad, soyad, T.C. kimlik no -gerektiğinde-, kullanıcı ID'si)
          <br><em>Amaç:</em> Hesap oluşturma, kimlik doğrulama, belediye hizmetlerinden yararlandırma, yasal yükümlülüklerin yerine getirilmesi.
        </li>
        <li><strong>İletişim Bilgileri</strong> (telefon, e-posta, adres)
          <br><em>Amaç:</em> Başvuru ve taleplere ilişkin iletişim, bildirim ve duyurular, güvenlik ve doğrulama işlemleri.
        </li>
        <li><strong>Konum Verileri</strong> (izin verilmesi halinde)
          <br><em>Amaç:</em> En yakın hizmet noktalarının gösterilmesi, konuma dayalı hizmetler (arıza bildirimi, çöp toplama, yol bakımı, park vb.), bölgesel acil durum bildirimleri.
        </li>
        <li><strong>İşlem ve Kullanım Verileri</strong>
          <br><em>Amaç:</em> Hizmetlerin sunulması ve iyileştirilmesi, hata tespiti, sistem güvenliği, performans analizi, istatistiksel raporlama (anonim hale getirilerek).
        </li>
        <li><strong>Cihaz ve Log Bilgileri</strong> (cihaz türü, IP adresi, uygulama sürümü, log kayıtları vb.)
          <br><em>Amaç:</em> Güvenlik, teknik bakım, hata ayıklama, performans optimizasyonu.
        </li>
        <li><strong>Fotoğraf/Dosya/Medya</strong> (Kullanıcı tarafından yüklenmesi halinde)
          <br><em>Amaç:</em> Başvuru ve şikayetlerin değerlendirilmesi, saha çalışmalarının planlanması.
        </li>
      </ul>
      <p>&nbsp;</p>

      <h3><strong>3. İşleme Hukuki Sebepleri</strong></h3>
      <p>Kişisel verileriniz, KVKK m.5/2'de düzenlenen;</p>
      <ul>
        <li>Kanunlarda açıkça öngörülmesi,</li>
        <li>Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması,</li>
        <li>Belediyenin hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması,</li>
        <li>Bir hakkın tesisi, kullanılması veya korunması için zorunlu olması,</li>
        <li>Temel hak ve özgürlüklerinize zarar vermemek kaydıyla Belediyenin meşru menfaati için zorunlu olması</li>
      </ul>
      <p>hukuki sebeplerine dayanılarak işlenebilir. Bu hallere girmeyen işleme faaliyetleri için açık rızanız alınmaktadır.</p>
      <p>&nbsp;</p>

      <h3><strong>4. Verilerin Aktarılması</strong></h3>
      <p>Kişisel verileriniz, amaçla sınırlı ve ölçülü olmak üzere;</p>
      <ul>
        <li>Belediyenin bağlı birim ve müdürlüklerine,</li>
        <li>Belediyenin hizmet aldığı tedarikçilerine (bilgi işlem, güvenlik, çağrı merkezi vb.),</li>
        <li>Yasal zorunluluk halinde yetkili kamu kurum ve kuruluşları ile yargı mercilerine</li>
      </ul>
      <p>aktarılabilir.</p>
      <p>Yurtdışına aktarım, ilgili mevzuat şartlarının sağlanması ve gerekiyorsa açık rızanızın alınması halinde söz konusu olabilir.</p>
      <p>&nbsp;</p>

      <h3><strong>5. Veri Saklama Süresi</strong></h3>
      <p>Kişisel verileriniz, ilgili mevzuatta öden öngörülen veya işleme amaçları için gerekli olan süre boyunca saklanır; bu sürelerin sona ermesi halinde mevzuata uygun şekilde silinir, yok edilir veya anonim hale getirilir.</p>
      <p>&nbsp;</p>

      <h3><strong>6. Çerezler (Cookies) ve Benzeri Teknolojiler</strong></h3>
      <p>"İskenderun Belediyesi" mobil uygulaması, teknik olarak zorunlu olduğu ölçüde çerezler ve benzeri teknolojiler kullanabilir.</p>
      <ul>
        <li><strong>Zorunlu çerezler:</strong> Uygulama'nın çalışması için gereklidir.</li>
        <li><strong>Analitik çerezler:</strong> Kullanıcı deneyimini geliştirmek amacıyla kullanılabilir.</li>
      </ul>
      <p>Detaylı bilgi, varsa ayrıca yayınlanacak Çerez Politikası'nda sunulacaktır.</p>
      <p>&nbsp;</p>

      <h3><strong>7. Güvenlik Tedbirleri</strong></h3>
      <p>Belediye, kişisel verilerinizi korumak için teknik ve idari tedbirler almaktadır. Bu kapsamda erişim yetkilerinin sınırlandırılması, şifreleme, yedekleme, loglama ve çalışanlara KVKK farkındalık eğitimleri gibi önlemler uygulanır.</p>
      <p>&nbsp;</p>

      <h3><strong>8. Haklarınız</strong></h3>
      <p>KVKK uyarınca;</p>
      <ul>
        <li>Kişisel verinizin işlenip işlenmediğini öğrenme,</li>
        <li>İşlenmış ise buna ilişkin bilgi talep etme,</li>
        <li>Amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
        <li>Yurt içinde veya yurtdışında aktarıldığı üçüncü kişileri bilme,</li>
        <li>Eksik/yanlış işlenmis ise düzeltilmesini isteme,</li>
        <li>KVKK'da öngörülen şartlar dahilinde silinmesini/yok edilmesini isteme,</li>
        <li>Bu işlemlerin ilgili üçüncü kişilere bildirilmesini isteme,</li>
        <li>Otomatik sistemlerce yapılan analiz sonucu aleyhinize bir sonuç çıkmasına itiraz etme,</li>
        <li>Zarara uğrarsanız zararın giderilmesini talep etme</li>
      </ul>
      <p>haklarına sahipsiniz.</p>
      <p>Bu haklarınızı kullanmak için Belediyenin internet sitesinde yer alan KVKK Başvuru Formu üzerinden veya <a href="mailto:bilgi@iskenderun.bel.tr">bilgi@iskenderun.bel.tr</a> adresine yazılı olarak başvurabilirsiniz.</p>
      <p>&nbsp;</p>

      <h3><strong>9. Politika Değişiklikleri</strong></h3>
      <p>Bu Gizlilik Politikası, hukuki ve teknik gelişmeler veya hizmet ihtiyaçları doğrultusunda Belediye tarafından güncellenebilir. Güncel metin, Uygulama içinde ve/veya Belediyenin resmi internet sitesinde yayınlandığı tarihten itibaren geçerlidir.</p>
      <p>&nbsp;</p>
    </div>
  </div>
</div>
  `;

  return (
    <div className="page-container">
      <div className="page-content">
        <QuickMenu />
        <main className="main-content">
          <div className="content-wrapper">
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
